import { render, staticRenderFns } from "./ListWidgetV2.vue?vue&type=template&id=1f4e371f&scoped=true"
import script from "./ListWidgetV2.vue?vue&type=script&lang=js"
export * from "./ListWidgetV2.vue?vue&type=script&lang=js"
import style0 from "./ListWidgetV2.vue?vue&type=style&index=0&id=1f4e371f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e371f",
  null
  
)

export default component.exports